import { create } from "./API";
import type { LowDpCalculationPayload } from "../helpers/interfaces/CalculatorInterfaces";

const CORE_API_URL = process.env.REACT_APP_INSTALLMENT_CORE_API_URL;

/**
 * POST /calculate/provider/low-dp
 * Calls the installment core API to compute provider-based low-DP calculations.
 */
export const calculateProviderLowDp = async (
  payload: LowDpCalculationPayload
) => {
  try {
    return await create(`${CORE_API_URL}/calculate/provider/low-dp`, payload);
  } catch (err: any) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    return err.message;
  }
};
